import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertController } from '@ionic/angular';

@Component({
	selector: 'app-menu-list-filters',
	templateUrl: './menu-list-filters.component.html',
	styleUrls: ['./menu-list-filters.component.scss'],
})
export class MenuListFiltersComponent implements OnInit {
	public addedFilters: string[] = [];
	public isOpenFilters = false;
	@Input() set addedFiltersValue(value: string[]) {
		this.addedFilters = value ?? [];
		console.log('HERE', this.addedFilters);
	}
	@Output() selectedFilters = new EventEmitter<string[]>();
	public listFilters = [
		{
			value: 'meat',
			name: 'features.meat',
		},
		{
			value: 'fish',
			name: 'features.fish',
		},
		{
			value: 'gluten',
			name: 'features.gluten',
		},
		{
			value: 'lactose',
			name: 'features.lactose',
		},
		{
			value: 'peanut',
			name: 'features.peanut',
		},
		{
			value: 'spicyLevel',
			name: 'features.spicy',
		},
		{
			value: 'vegan',
			name: 'features.vegan',
		},
	];
	constructor(public translate: TranslateService, private alertCtrl: AlertController) {}

	ngOnInit() {}

	selectFilters() {
		this.selectedFilters.emit(this.addedFilters);
	}

	changeVariable(event: any, value: string) {
		if (event?.detail?.checked) {
			this.addedFilters.push(value);
		} else {
			this.addedFilters = this.addedFilters.filter(it => it != value);
		}
		this.selectedFilters.emit(this.addedFilters);
	}

	async allergensInfoAlertOpen(event: MouseEvent) {
		event.stopPropagation();
		event.preventDefault();

		const alert = await this.alertCtrl.create({
			cssClass: 'allergens-alert-info',
			message: '',
			buttons: [
				{
					text: this.translate.instant('allergenes.modal.btn'),
					role: 'submit',
					handler: () => {
						window.open(
							/Android|iPhone/.test(navigator.userAgent)
								? 'https://drive.google.com/file/d/1q4LPDpreLSMRPOjv3YNC1WSoyO7ID9V1/view'
								: 'https://drive.google.com/file/d/1thioSJYJ5cjnJpPP9_hz9pI3x6WUQ_fz/view',
							'_blank'
						);
					},
				},
			],
		});
		alert.present();

		const messageEl = document.querySelector('ion-alert .alert-message');
		if (messageEl) {
			messageEl.innerHTML = this.translate.instant('allergenes.modal.message');
		}

		const res = await alert.onDidDismiss();
		console.log(res);
	}
}
